import {ComponentProps, FC} from 'react';

export const IconDiamond: FC<ComponentProps<'svg'>> = ({
    color = 'var(--color-icon-primary)',
    width = 24,
    height = 24,
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            {...rest}
        >
            <path
                d="M12.1609 3.44922H11.8409L9.21086 8.69922H14.7909L12.1609 3.44922Z"
                fill={color}
            />
            <path
                d="M16.4609 8.69922H21.6209L19.5509 4.55922C19.2109 3.87922 18.5209 3.44922 17.7609 3.44922H13.8309L16.4609 8.69922Z"
                fill={color}
            />
            <path
                d="M21.3809 10.1992H12.7509V20.5492L21.3809 10.1992Z"
                fill={color}
            />
            <path
                d="M11.2509 20.5492V10.1992H2.62086L11.2509 20.5492Z"
                fill={color}
            />
            <path
                d="M7.54086 8.69922L10.1609 3.44922H6.24086C5.48086 3.44922 4.79086 3.87922 4.45086 4.55922L2.38086 8.69922H7.54086Z"
                fill={color}
            />
        </svg>
    );
};
